var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KDialog',{attrs:{"show-close":"","max-width":"900px","visible":_vm.visible,"title":`Visualizar Coleta #${_vm.form.id}`,"actions":_vm.buttons},on:{"click:close":_vm.close,"click:next":_vm.onNextClick,"click:previous":_vm.onPreviousClick}},[_c('CollectionView',{attrs:{"collection":_vm.form}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }